module.exports = __webpack_public_path__ + "static/media/SM-ST-intro (1).4a65c4a9.mp3";